module.exports = __webpack_public_path__ + "img/preferably.ef086d29.png";